import React from 'react';
import styled from 'styled-components';
import {
  SkeletonButton,
  SkeletonHeader,
  SkeletonSmallSection,
} from './LoadingCourse.component';

const SkeletonSectionDark = styled.section`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.grey4};
  gap: 0.5rem;
  min-height: 50%;
  align-items: start;
  justify-content: center;
  padding: 3rem;
`;
const SkeletonSectionLight = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.grey};
  padding-top: ${({ theme }) => theme.spacing.l};
  min-height: 50%;
`;
export const SkeletonOuter = styled.main`
  display: flex;
  width: 100%;
  height: 100vh;
  flex-direction: column;
`;
export const SkeletonRow = styled.div`
  display: flex;
  width: 50%;
  gap: 1rem;
`;

const LoadingQuizCompletePage = () => {
  return (
    <SkeletonOuter>
      <SkeletonSectionDark>
        <SkeletonHeader />
        <SkeletonRow>
          <SkeletonButton />
          <SkeletonButton />
        </SkeletonRow>
      </SkeletonSectionDark>
      <SkeletonSectionLight>
        <SkeletonSmallSection />
      </SkeletonSectionLight>
    </SkeletonOuter>
  );
};

export default LoadingQuizCompletePage;
